import type { FC } from "react";
import { IoIosClose } from "react-icons/io";
import { EstadisticasModal } from "../EstadisticasModal/EstadisticasModal";
import { GastosDiariosModal } from "../GastosDiariosModal/GastosDiariosModal";
import { VerTablaClientesModal } from "../VerTablaClientesModal/VerTablaClientesModal";
import { useVerDetallesRutasModal } from "./verDetallesRutasModalHooks";
import type { VerDetallesRutasModalProps } from "./types";

export const VerDetallesRutasModal: FC<VerDetallesRutasModalProps> = (props) => {
  const modalState = useVerDetallesRutasModal(props);

  if (!modalState) {
    return null;
  }

  const {
    clientes,
    handleClose,
    handleCloseEstadisticas,
    handleCloseGastos,
    handleCloseVerClientes,
    handleOpenEstadisticas,
    handleOpenGastos,
    handleOpenVerClientes,
    selectedRuta,
    verClientes,
    verEstadisticas,
    verGastos,
  } = modalState;

  return (
    <>
      {verClientes ? (
        <VerTablaClientesModal
          clientes={clientes}
          selectedRuta={selectedRuta}
          setVerClientes={handleCloseVerClientes}
          setSelectedRuta={props.setSelectedRuta}
        />
      ) : null}

      {verGastos ? (
        <GastosDiariosModal
          setVerGastos={handleCloseGastos}
          selectedRuta={selectedRuta}
        />
      ) : null}

      {verEstadisticas ? (
        <EstadisticasModal
          clientes={clientes}
          selectedRuta={selectedRuta}
          setVerEstadisticas={handleCloseEstadisticas}
        />
      ) : null}

      <div className="w-full min-h-screen h-screen z-20 bg-black bg-opacity-50 px-2 md:px-8 flex justify-center items-center fixed top-0 left-0">
        <div className="bg-gray-200 w-[400px] md:w-full p-4 md:h-full rounded-md relative max-h-[90%] overflow-y-auto">
          <div className="absolute right-2 top-2 cursor-pointer bg-white rounded-[50%] p-[1px]">
            <IoIosClose size={40} onClick={handleClose} />
          </div>

          <h2 className="text-center font-bold text-lg">
            {`Detalles Ruta ${selectedRuta.nombreRuta}`}
          </h2>

          <button
            type="button"
            className="bg-[#8131bd] mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
            onClick={handleOpenVerClientes}
          >
            Ver Clientes
          </button>

          <button
            type="button"
            className="bg-[#8131bd] mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
            onClick={handleOpenGastos}
          >
            Ver Gastos Diarios
          </button>

          <button
            type="button"
            className="bg-[#8131bd] mt-2 w-fit text-white px-2 py-1 rounded-md flex justify-center items-center min-w-[80px]"
            onClick={handleOpenEstadisticas}
          >
            Ver Estadisticas
          </button>
        </div>
      </div>
    </>
  );
};
